import React, { useEffect, useRef, useState } from "react";
import { FiCheck, FiCopy, FiLink, FiPrinter } from "react-icons/fi";
import styles from "./ArticleTools.module.css";

const ArticleTools = ({ url }) => {
  const [copyStatus, setCopyStatus] = useState("idle");
  const resetTimer = useRef(null);

  useEffect(() => {
    setCopyStatus("idle");
    return () => window.clearTimeout(resetTimer.current);
  }, [url]);

  const copyLink = async () => {
    window.clearTimeout(resetTimer.current);
    setCopyStatus("copying");
    try {
      if (!navigator.clipboard) throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(url);
      setCopyStatus("copied");
      resetTimer.current = window.setTimeout(() => setCopyStatus("idle"), 3000);
    } catch {
      setCopyStatus("error");
    }
  };

  return (
    <section className={styles.card} aria-label="ابزارهای مقاله">
      <span className={styles.icon}>
        <FiLink aria-hidden="true" />
      </span>
      <h2>ابزارهای مقاله</h2>
      <p>لینک را بفرستید یا نسخه‌ی چاپی بگیرید.</p>
      <div className={styles.actions}>
        <button
          type="button"
          onClick={copyLink}
          disabled={copyStatus === "copying"}>
          {copyStatus === "copied" ? (
            <FiCheck aria-hidden="true" />
          ) : (
            <FiCopy aria-hidden="true" />
          )}
          {copyStatus === "copied"
            ? "لینک کپی شد"
            : copyStatus === "copying"
            ? "در حال کپی…"
            : "کپی لینک مقاله"}
        </button>
        <button
          type="button"
          className={styles.print}
          onClick={() => window.print()}>
          <FiPrinter aria-hidden="true" /> چاپ / ذخیره PDF
        </button>
      </div>
      <div className={styles.feedback} role="status" aria-live="polite">
        {copyStatus === "copied" && "لینک مقاله آماده‌ی اشتراک‌گذاری است."}
        {copyStatus === "error" && (
          <>
            <label htmlFor="article-share-url">
              کپی خودکار انجام نشد؛ لینک را از کادر زیر کپی کنید.
            </label>
            <input
              id="article-share-url"
              dir="ltr"
              value={url}
              readOnly
              onFocus={event => event.currentTarget.select()}
            />
          </>
        )}
      </div>
    </section>
  );
};

export default ArticleTools;
